export default {
  helpCenterPageTitle: {
    id: 'hc_page_title',
    defaultMessage: 'Back Market – Help Center',
  },
}
